import Vue from 'vue'
import axios from 'axios'
import config from '@/config'
import storeConfigModel from '@/controllers/storeController/models/config/config.model'
import StoreController from '@/controllers/storeController/view/store/store.controller.js'
import { Toast } from 'vant'
import {
  removeLocal,
  getToken,
  getCookie,
  getUrlParam,
  isPCBrowser,
  isEqual,
  getMyCookie,
  delay,
  getParamsByKey,
} from '../utils'
import qs from 'qs'
import useMiniappParams from './middleware/useMiniappParams'
import { webLog } from '@/plugin/webLog'

const store_id_key = storeConfigModel.STORE_ID_KEY
// const CancelToken = axios.CancelToken
// 删除请求 pageurl 中的authData参数
const urlRegex = /([&?])authData=[^&]+(&|$)/gi

class HttpRequest {
  constructor(baseUrl = '') {
    this.headers = {}
    this.baseURL = baseUrl
    this.pending = {}
    // loading对象
    this.loading = null
    // 兼容小程序内嵌页面
    this.MiniAppData = {}
    this.inited = false
  }

  async init() {
    // 兼容小程序内嵌页面
    try {
      this.MiniAppData = await useMiniappParams()
      this.inited = true
    } catch (error) {
      this.inited = true
    }
  }

  // 显示loading
  showLoading() {
    if (this.loading == null) {
      this.loading = Toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true,
      })
    }
  }

  // 隐藏loading
  hideLoading() {
    if (this.loading) {
      this.loading.close()
      this.loading = null
    }
  }
  // 获取axios配置
  async getInsideConfig(options) {
    const config = {
      baseURL: this.baseUrl,
      headers: Object.assign(
        {},
        {
          // 'content-type': 'application/json',
          Authorization: options.noToken ? '' : `Bearer ${getToken()}`,
          buid: getCookie('zbvz_userid'),
          pageurl: window.location.href.replace(urlRegex, '$1'),
          'zbvz-userid':
            location.host.includes('localhost') ||
            location.host.includes('wx-dev') ||
            location.host.includes('testvt.vzan.com')
              ? getCookie('zbvz_userid')
              : '',
        },
        this.headers
      ),
      timeout: options && options.timeout ? options.timeout : 30000,
    }
    // 知播接口
    if (options.zhibo) {
      config.headers = Object.assign(config.headers, {
        zbid: getUrlParam('zbid') || window.zbvd.zbid,
      })
      if (getUrlParam('tpid')) {
        config.headers = Object.assign(config.headers, {
          'topic-id': getUrlParam('tpid') || '',
        })
      }
    }
    if (options.customHeaders) {
      config.headers = { ...config.headers, ...options.customHeaders }
    }

    if (options.form) {
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    }
    // 第一次请求前 初始化参数
    if (!this.inited) {
      await this.init()
    }
    return config
  }

  removePending(key, isRequest = false) {
    if (this.pending[key] && isRequest) {
      this.pending[key]('取消重复请求' + key)
    }
    delete this.pending[key]
  }

  // 设定拦截器
  interceptors(instance) {
    // 请求拦截器
    instance.interceptors.request.use(
      config => {
        // 判断当前请求是否设置了不显示 Loading
        if (config.showLoading !== false) {
          this.showLoading()
        }
        // 兼容旧接口
        const preUrl = [
          '/liveajax/',
          '/LiveAjax/',
          '/mall/',
          '/nlive/',
          '/NLive/',
          '/live/',
        ]
        if (
          preUrl.filter(item => config.url.includes(item)).length &&
          !config.url.includes('/marketing/live/') && // java 接口带有live 误判为老接口
          !config.url.includes('/open-api/') &&
          !config.url.includes('/scrm-open-api/')
        ) {
          // console.log('config.url', config.url)
          config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
        }
        if (config.contentType) {
          config.headers['Content-Type'] = config.contentType
        }
        if (
          config.method.toLocaleLowerCase() === 'get' ||
          config.method.toLocaleLowerCase() === 'delete'
        ) {
          config.params = config.data
        }

        // 小程序环境携带 小程序参数
        config = this.MiniAppData.formatMiniAppParams(config)
        return config
      },
      error => {
        this.hideLoading()
        let err = {}
        if (typeof error == 'object') {
          error.massageText = '请求拦截器报错'
          err = error
        } else {
          err = {
            error,
            massageText: '请求拦截器报错',
          }
        }
        return Promise.reject(err)
      }
    )

    // 响应请求的拦截器
    instance.interceptors.response.use(
      res => {
        this.hideLoading()

        if (res.status === 200) {
          // PC 未登录跳转 个人中心登录
          // code: 4008 msg: "请用微信打开链接登录" success: false
          if (res.data.code === 4008 && !res.data.success && isPCBrowser()) {
            localStorage.setItem(
              'wx-prelogin-page',
              encodeURIComponent(window.location.href)
            )
            setTimeout(() => {
              window.location.href = '/live/mine?zbid=' + window.zbvd.zbid
            }, 1500)
            return
          }
          return Promise.resolve(res)
        } else {
          return Promise.reject(res)
        }
      },
      error => {
        this.hideLoading()
        let err = {}
        if (typeof error == 'object') {
          error.massageText = '响应请求报错'
          err = error
        } else {
          err = {
            error,
            massageText: '响应请求报错',
          }
        }
        // 收集接口请求错误的信息
        try {
          const captureData = {
            uid: getCookie('zbvz_userid'),
          }
          const errorData =
            typeof error.toJSON == 'function' ? error.toJSON() : {}
          // 基础信息
          if (errorData.config) {
            captureData.url = errorData.config.url
            captureData.method = errorData.config.method
            captureData.payload =
              errorData.config.method == 'post'
                ? errorData.config.data
                : errorData.config.params
            captureData.message = errorData.message
          } else {
            captureData.message = error.message
            captureData.stack = error.stack.toString()
          }
          // 响应状态
          if (error.response) {
            captureData.status = error.response.status
            captureData.statusText = error.response.statusText
            captureData.responseData = error.response.data
          }
          console.warn(captureData)
          // 提交埋点到 elasitc
          // window.$apm && window.$apm.captureError(new Error(errorString))
          webLog({
            msg: 'xhr-接口报错',
            captureData,
          })
        } catch (error) {
          console.log(error)
        }
        return Promise.reject(err)
      }
    )
  }

  // 创建实例
  async request(options) {
    const instance = axios.create({
      withCredentials: options.zhibo ? true : false,
    })
    const newOptions = Object.assign(
      await this.getInsideConfig(options),
      options
    )
    this.interceptors(instance)
    return instance(newOptions)
  }

  get(url, data, showLoading, options = {}) {
    return this.request(
      Object.assign(
        {
          method: 'get',
          url,
          data,
          showLoading,
        },
        options
      )
    )
  }

  post(url, data, showLoading, options = {}) {
    return this.request(
      Object.assign(
        {
          method: 'post',
          url,
          data: options && options.form ? qs.stringify(data) : data,
          showLoading,
        },
        options
      )
    )
  }

  put(url, data, showLoading, options = {}) {
    return this.request(
      Object.assign(
        {
          method: 'put',
          url,
          data,
          showLoading,
        },
        options
      )
    )
  }

  delete(url, data, showLoading, options = {}) {
    return this.request(
      Object.assign(
        {
          method: 'delete',
          url,
          data,
          showLoading,
        },
        options
      )
    )
  }

  patch(url, data, showLoading, options = {}) {
    return this.request(
      Object.assign(
        {
          method: 'patch',
          url,
          data,
          showLoading,
        },
        options
      )
    )
  }
}

/**
 * 请求统一处理
 * @param {*} responData
 * @param {*} options
 * @param {*} mode  门店系统 store
 * @returns
 */
function requst(responData, options = {}, mode) {
  return new Promise((resolve, reject) => {
    responData
      .then(res => {
        // console.log(res.headers['content-type'])
        // console.log(res.headers['content-type'] === 'application/octet-stream')
        // 最高优先级 返回原始结果

        if (options.rawRes) {
          resolve(res.data)
          return
        }
        if (
          res.headers['content-type'] === 'application/vnd.ms-excel' ||
          res.headers['content-type'] === 'application/ms-excel' ||
          res.headers['content-type'] === 'application/octet-stream' ||
          res.headers['content-type'] ===
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
        ) {
          resolve(res)
        }
        // test: 开发种，暂时注释接口校验
        if (
          (res.data.code === -1 || res.data.code === 4006) &&
          mode === 'store'
        ) {
          let err = {
            error: res,
            massageText: res.data.msg,
          }

          setTimeout(() => {
            StoreController.goStoreLogin()
          }, 1500)
          return reject(err)
        }
        if (
          res.data.isok ||
          (res.data.isok === undefined && res.data.code === 0)
        ) {
          // 旧接口逻辑处理
          const preUrl = [
            '/liveajax/',
            '/LiveAjax/',
            '/mall/',
            '/nlive/',
            '/NLive/',
            '/live/',
            '/v1',
          ]

          if (preUrl.filter(item => res.config.url.includes(item)).length) {
            resolve(res.data)
          } else {
            const CODE = Number.parseInt(res.data.code)
            if (CODE === 0 || CODE === 200 || CODE == -10 || res.data.isok) {
              // 请求成功
              return resolve(res.data)
            } else if (CODE === -1 || CODE === 1001) {
              // Token过期 || 账号不存在
              // 清除localStorage存储信息
              removeLocal(config.COOKIE_KEY)
              removeLocal(config.TOKEN_KEY)
              if (CODE === -1) {
                Vue.prototype.$toast('登录信息失效，请重新刷新页面')
              }
            }
            reject(
              res.data.msg ||
                res.data.Msg ||
                res.data.message ||
                '加载数据超时，请稍后重试'
            )
          }
        } else if (options.allRes) {
          reject(res.data)
        } else if (options.allResolve) {
          resolve(res.data)
        } else if (options.getRes) {
          resolve(res.data)
        } else {
          reject(
            res.data.msg ||
              res.data.Msg ||
              res.data.message ||
              '查询不到数据呢 联系管理员处理吧'
          )
        }
      })
      .catch(error => {
        if (
          error.config &&
          error.message.includes(
            `timeout of ${error.config.timeout}ms exceeded`
          )
        ) {
          reject('加载数据超时，请稍后重试')
        } else {
          let err = {}
          if (typeof error == 'object') {
            error.massageText = '请求报错返回'
            err = error
          } else {
            err = {
              error,
              massageText: '请求报错返回',
            }
          }
          reject(err)
        }
      })
  })
}

const service = new HttpRequest()
// 挂载请求
Vue.prototype.$axios = service

// get.post.put.del.patch请求方法提取
const get = (url, params, showLoading = true, options) => {
  return requst(service.get(url, params, showLoading, options), options)
}
const post = (url, params, showLoading = true, options = {}) => {
  return requst(service.post(url, params, showLoading, options), options)
}
const put = (url, params, showLoading = true, options) => {
  return requst(service.put(url, params, showLoading, options))
}
const del = (url, params, showLoading = true, options) => {
  return requst(service.delete(url, params, showLoading, options))
}
const patch = (url, params, showLoading = true, options) => {
  return requst(service.patch(url, params, showLoading, options))
}

const getStore = (
  url,
  params,
  showLoading = true,
  haederOptions,
  options = {}
) => {
  // 门店，区域，分公司
  const userType = StoreController.storeUserType()
  const apiHeaderOption = {
    ...haederOptions,
    ...StoreController.apiHeaderConfig(),
  }
  let paramsData = {
    ...params,
    zbId: StoreController.zbId(),
  }
  paramsData[store_id_key[userType]] = options.noStoreId
    ? 0
    : StoreController.storeId()
  return requst(
    service.get(url, paramsData, showLoading, apiHeaderOption),
    apiHeaderOption,
    'store'
  )
}

const postStore = (
  url,
  params,
  showLoading = true,
  haederOptions = {},
  options = {}
) => {
  // 门店，区域，分公司
  const userType = StoreController.storeUserType()
  const apiHeaderOption = {
    ...haederOptions,
    ...StoreController.apiHeaderConfig(),
  }
  let paramsData = {
    ...params,
    zbId: StoreController.zbId(),
  }
  paramsData[store_id_key[userType]] = options.noStoreId
    ? 0
    : StoreController.storeId()
  return requst(
    service.post(url, paramsData, showLoading, apiHeaderOption),
    apiHeaderOption,
    'store'
  )
}

/**
 * 创建一个新的请求函数 多次调用只会发起一次请求（拿到的是上次请求的结果）
 * @param {{
 *   requestType: String
 *   ?timeout: Number,
 *   ?sameArgs: Boolean
 * }} options 配置项 可选
 * @param {Number} options.requestType 请求类型 get post put del patch
 * @param {Number} options.timeout 规定时间内只发起一次请求 (毫秒)
 * @param {Boolean} options.sameArgs 请求参数与上次不一致时重新发起请求（深度键值对比）
 * @return function
 */
export function createCacheAjax(options = { requestType: 'get' }) {
  let requestPromise = null
  let prevTime = Date.now()
  let prevArgs
  return async function (...args) {
    let isPassTime = true
    let isPassArgs = true
    if (options.timeout) {
      isPassTime = Date.now() - prevTime < options.timeout
    }
    if (options.sameArgs && prevArgs) {
      isPassArgs = isEqual(args, prevArgs)
    }
    if (!(requestPromise && isPassTime && isPassArgs)) {
      prevTime = Date.now()
      if (options.sameArgs) {
        prevArgs = args
      }
      requestPromise = REQUEST_TYPE[options.requestType.toLowerCase()](...args)
    }
    return requestPromise
  }
}
function debuggerRetry(url) {
  if (!url) return url
  try {
    const __debuger_retry = getParamsByKey('debuger_retry')
    const ypgw = url.includes('ypgw')
    if (__debuger_retry && !ypgw) {
      url = url.replace('vzan.com', 'evzan.com')
      const blackList = ['/public/config', 'create_or_update_sign', 'sing_in']
      for (let i = 0; i < blackList.length; i++) {
        if (url.indexOf(blackList[i]) > -1) {
          url = url.replace('marketing/', 'mark/eting')
        }
      }
    }
    return url
  } catch (error) {
    return url
  }
}

/**
 * 创建一个新的请求函数 请求失败会自动重试直到达到数量上限
 * @param {{
 *   ?maxCount: Number,
 *   ?gap: Number
 *   ?retryUrl: String | Array
 *   ?catchCallback: Function
 *   ?requestFn: Function
 * }} options 配置项 可选
 * @param {String | Array} options.retryUrl 最后一次重试的接口地址 如果是数组 则以数组长度n作为最后重试的n次请求 n比maxCount大时 maxCount取n
 * @param {Number} options.maxCount 最大重试次数
 * @param {Boolean} options.gap 重试间隔时间
 * @param {function} options.catchCallback 当请求进入catch时，catchCallback的返回值为true不会重试请求(以请求的返回值作为参数)
 * @param {function} options.requestFn 自定义请求函数
 * @return {function}
 */
function retryAjax(options = {}) {
  let {
    maxCount = 2,
    gap = 1500,
    catchCallback,
    requestFn = requst,
    retryUrl,
    loading = false,
  } = options
  let loadingObj = null
  let retryCount = 0
  let retryUrlList
  if (retryUrl) {
    retryUrlList = Array.isArray(retryUrl) ? retryUrl : [retryUrl]
    maxCount = Math.max(retryUrlList.length, maxCount)
  }

  return async function fn(...args) {
    try {
      args[0] = debuggerRetry(args[0])
      const res = await requestFn.apply(this, args)
      return Promise.resolve(res)
    } catch (e) {
      if (typeof catchCallback === 'function') {
        if (catchCallback(e) === true) {
          return Promise.reject(e)
        }
      }
      if (retryUrlList && retryCount == maxCount - retryUrlList.length) {
        args[0] = retryUrlList.shift()
      }
      try {
        const data = {
          title: `请求失败重试-${retryCount}-${maxCount}`,
          cookie: getMyCookie() || '',
          options,
          args,
        }
        if (window.zbvd) {
          data.tpid = window.zbvd.tpid
          data.zbid = window.zbvd.zbid
        }
        if (e instanceof Error) {
          data.error = e.message
        } else if (typeof e == 'object') {
          data.error = JSON.stringify(e)
        } else if (typeof e == 'string') {
          data.error = e
        }
        webLog(data)
      } catch (error) {
        console.log('请求错误 提交埋点到 elastic')
      }
      if (retryCount < maxCount) {
        if (loading) {
          loadingObj = Toast.loading({
            duration: 0,
            message: '加载中...',
            forbidClick: true,
          })
        }
        if (gap == 'random') {
          // 随机二到五秒
          gap = Math.floor(Math.random() * 3000) + 2000
        }
        await delay(gap)
        retryCount++
        loadingObj && loadingObj.close()
        return Promise.resolve(fn(...args))
      } else {
        return Promise.reject(e)
      }
    }
  }
}

/**
 * 请求类型枚举
 * @type {{patch: (function(*, *, boolean=, *): Promise<unknown>), post: (function(*, *, boolean=, {}=): Promise<unknown>), get: (function(*, *, boolean=, *): Promise<unknown>), del: (function(*, *, boolean=, *): Promise<unknown>), put: (function(*, *, boolean=, *): Promise<unknown>)}}
 */
const REQUEST_TYPE = {
  get: get,
  post: post,
  put: put,
  del: del,
  patch: patch,
}

export { service }
export { get, post, put, del, patch, retryAjax, getStore, postStore }
